import {AfterViewInit, Component, Inject, Injector, OnDestroy, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {of, Subscription} from 'rxjs';
import {INITIAL_LAYOUT} from './layout-config';
import {ActivatedRoute} from '@angular/router';
import {ConfigService, ErrorsService, User} from 'shared';
import {GoldenLayoutComponent, GoldenLayoutComponentHost, GoldenLayoutContainer} from 'ngx-golden-layout';
import {LayoutService} from './layout.service';
import drawLocales from 'leaflet-draw-locales';
import GoldenLayout from 'golden-layout';
import {createCustomElement, NgElement, WithProperties} from '@angular/elements';
import {MapTractorPopupComponent} from '../map-tractors/map-tractor-popup/map-tractor-popup.component';
import {MapSidebarTabsComponent} from '../map-sidebar-tabs/map-sidebar-tabs.component';
import {VERSION, BuildTime} from '../../environments/version';
import {Settings} from '../settings/settings.service';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{
    provide: User,
    useFactory: (route: ActivatedRoute) => {
      return route.snapshot.data.user;
    },
    deps: [ActivatedRoute]
  }, {
    provide: Settings,
    useFactory: (route: ActivatedRoute) => {
      return route.snapshot.data.settings;
    },
    deps: [ActivatedRoute]
  }]
})
export class HomeComponent implements OnInit, OnDestroy, AfterViewInit {

  layoutConfig$ = of(INITIAL_LAYOUT);

  @ViewChild(GoldenLayoutComponent, {static: true})
  layout: GoldenLayoutComponent;
  versionPopupVisible: boolean;
  AppBuildInfo = VERSION;
  AppBuildTime = BuildTime;
  APIBuildInfo = {version: 'unset', build_time: 'unset'};

  constructor(
    injector: Injector,
    protected layoutService: LayoutService,
    public errors: ErrorsService,
    private http: HttpClient,
    private config: ConfigService
  ) {

    // Automatically defines Leaflet.draw to the specified language
    drawLocales('fr');


    // Convert `MapTractorPopupComponent` to a custom element.
    const HeaderElement = createCustomElement(MapSidebarTabsComponent, {injector});
    // Register the custom element with the browser.
    customElements.define('map-sidebar-header', HeaderElement);
  }

  ngOnInit(): void {
    this.layoutService.layout = this.layout;
  }

  ngOnDestroy(): void {
  }

  ngAfterViewInit(): void {
    let popupEl: NgElement & WithProperties<MapSidebarTabsComponent> = null;
    popupEl = document.createElement('map-sidebar-header') as any;

    const el = this.layout.getGoldenLayoutInstance().root.getItemsById('map-side-stack')[0].element;
    // @ts-ignore
    el.addClass('map-side-stack').find('.lm_header').replaceWith(popupEl);
  }
  getVersion(e: any) {
    this.http.get(this.config.apiUrl('/version')).subscribe(data => this.APIBuildInfo = data as any);
  }
}
